var initialState = {
    shortDescription: null,
    validationError: null
};

function validate(newState) {
    newState.validationError =
        newState.shortDescription && newState.shortDescription.trim() !== ''
            ? null
            : 'syi_validation_missing_title';
    return newState;
}

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SET_SHORT_DESCRIPTION':
            return validate({ ...state, shortDescription: action.payload });
        case 'RESET_SHORT_DESCRIPTION':
            return validate({ ...state, shortDescription: null });
        default:
            return state;
    }
};
